var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{'box-loading': _vm.loading},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.resendInvite()}}},[_vm._v("\n  "+_vm._s(_vm.$t('Resend invitation'))+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42824abf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/MemberInviteResendInvite.vue
// module id = null
// module chunks = 